import React, { useCallback, useState } from 'react'
import { CustomFieldType } from '../../../../types/custom-fields/custom-field-type'
import { CustomFieldInput } from './CustomFieldInput'
import { CheckboxField } from '../CheckboxField'
import { FieldSaveButton } from '../buttons/FieldSaveButton'
import { FieldCancelButton } from '../buttons/FieldCancelButton'
import { FieldEditButton } from '../buttons/FieldEditButton'
import { TextField } from '../TextField'

export interface Props {
  value: string | number | boolean | undefined // typeof
  type: CustomFieldType
  className?: string
  onChange: (value: string | number | boolean | undefined) => void
  save: () => Promise<void>
}

export function InlineFieldInput({ value, className, onChange, save, type }: Props): JSX.Element {
  const [originalValue] = useState(value)
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const [isSaving, setIsSaving] = useState<boolean>(false)

  const onEdit = () => {
    setIsEditing(true)
  }

  const onSave = useCallback(async () => {
    try {
      setIsSaving(true)
      await save()
      setIsEditing(false)
    } catch {
      // TODO: Handle error
    } finally {
      setIsSaving(false)
    }
  }, [save])

  const onCancel = () => {
    onChange(originalValue) // Reset value
    setIsEditing(false)
  }

  return (
    <div className={`relative w-full h-fit flex gap-2`.concat(className ? ` ${className}` : '')}>
      {isEditing ? (
        <CustomFieldInput value={value} onChange={onChange} onEnter={onSave} type={type} />
      ) : type === 'checkbox' ? (
        <CheckboxField value={value as boolean} />
      ) : (
        <TextField value={value as string} />
      )}
      {isEditing ? (
        <div className="flex gap-2">
          <FieldSaveButton onClick={onSave} loading={isSaving} />
          <FieldCancelButton onClick={onCancel} disabled={isSaving} />
        </div>
      ) : (
        <FieldEditButton onClick={onEdit} />
      )}
    </div>
  )
}
